import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class CouponApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/coupons'
    }

    clone(id) {
        return ResponseHandler.handle(
            apiClient.put(this.getItemIri(id, 'clone'))
        )
    }

    get(id) {
        return ResponseHandler.handle(apiClient.get(this.getItemIri(id)))
    }
}

export default new CouponApiClient()
